<div class="page-wrapper section-hr-direct">

    <app-left-menu></app-left-menu>
  
  
    <div id="main-container">
      <app-header [title]="title"></app-header>
  
      <div class="content-header">
  
      </div>
      <div class="page-content settings">
        <div class="content-mid no-absolute">
          <div class="link-blocks m-t75 m-l100">
            <div class="image-container">

              <div class="video-large enter">
                <a  (click)="RedirectURL()"  class="enter-button">{{'Enter'}}</a>
                <img src="assets/images/ecaregivers_background.jpg">
            
              </div>
            </div>
          </div>
        </div> 
      </div>
    </div>
</div>


